import { openDB } from 'idb'

const DB_NAME = 'my-vue-idb'
const STORE_NAME = 'meta-store'
const VERSION = 2

let dbInstance = null

async function getDb () {
  if (dbInstance) return dbInstance

  dbInstance = await openDB(DB_NAME, VERSION, {
    upgrade (db) {
      if (db.objectStoreNames.contains(STORE_NAME)) {
        db.deleteObjectStore(STORE_NAME)
      }
      db.createObjectStore(STORE_NAME)
    }
  })

  return dbInstance
}

export default {
  async set (key, value) {
    const db = await getDb()
    await db.put(STORE_NAME, value, key) // will replace if key exists
  },

  async get (key) {
    const db = await getDb()
    return await db.get(STORE_NAME, key)
  },

  async delete (key) {
    const db = await getDb()
    await db.delete(STORE_NAME, key)
  },

  async clear () {
    const db = await getDb()
    await db.clear(STORE_NAME)
  },

  async push (key, value) {
    const db = await getDb()
    const existingData = await db.get(STORE_NAME, key)
    if (existingData && Array.isArray(existingData)) {
      existingData.push(value)
      await db.put(STORE_NAME, existingData, key)
    } else {
      await db.put(STORE_NAME, [value], key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/indexedDb.js